import { render, staticRenderFns } from "./FarmDetail.vue?vue&type=template&id=bea83fe4&"
import script from "./FarmDetail.vue?vue&type=script&lang=js&"
export * from "./FarmDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports